const ACCOUNT_ID_PATTERN = /^\d{10}$/;

/** Strip non-digits (e.g. `488-992-1856` → `4889921856`). */
export function normalizeAccountCardId(id: string): string {
	return String(id).replace(/\D/g, "");
}

/** Google Ads display form: `1197683848` → `119-768-3848` (DAI-1217). */
export function formatAccountCardId(id: string): string {
	const digits = normalizeAccountCardId(id);
	if (digits.length === 10) {
		return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
	}
	return String(id);
}

export function isValidAccountCardId(id: string): boolean {
	return ACCOUNT_ID_PATTERN.test(normalizeAccountCardId(id));
}
